import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import { initAnalytics } from "./lib/analytics";
import "./styles/globals.css";

const Loading = (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <span className="font-mono text-accent">Loading...</span>
  </div>
);

// Code-split all secondary pages — not needed on initial load
const ClevelandRoute = lazy(() => import("./components/ClevelandRoute"));
const DiscoverySprint = lazy(() => import("./pages/DiscoverySprint"));
const BuildLaunch = lazy(() => import("./pages/BuildLaunch"));
const AiSystemsPage = lazy(() => import("./pages/AiSystemsPage"));
const About = lazy(() => import("./pages/About"));
const CaseStudies = lazy(() => import("./pages/CaseStudies"));
const Interlock = lazy(() => import("./pages/case-studies/Interlock"));
const Apozy = lazy(() => import("./pages/case-studies/Apozy"));
const RADwood = lazy(() => import("./pages/case-studies/RADwood"));
const VelocityMarkets = lazy(() => import("./pages/case-studies/VelocityMarkets"));
const SecurityCareer = lazy(() => import("./pages/case-studies/SecurityCareer"));
const BlogIndex = lazy(() => import("./pages/blog/BlogIndex"));
const WhyMvpsFail = lazy(() => import("./pages/blog/WhyMvpsFail"));
const SixFiftyKUsers = lazy(() => import("./pages/blog/SixFiftyKUsers"));
const DiscoveryVsDesignSprint = lazy(() => import("./pages/blog/DiscoveryVsDesignSprint"));
const MvpCost2026 = lazy(() => import("./pages/blog/MvpCost2026"));
const WhenToHireFractionalCto = lazy(() => import("./pages/blog/WhenToHireFractionalCto"));
const YcLessons = lazy(() => import("./pages/blog/YcLessons"));
const FindingPmf = lazy(() => import("./pages/blog/FindingPmf"));

initAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Suspense fallback={Loading}>
        <Routes>
          <Route path="/" element={<App />} />

          {/* Service pages */}
          <Route path="/discovery-sprint" element={<DiscoverySprint />} />
          <Route path="/build-launch" element={<BuildLaunch />} />
          <Route path="/ai-systems" element={<AiSystemsPage />} />

          {/* About */}
          <Route path="/about" element={<About />} />

          {/* Case studies */}
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/interlock" element={<Interlock />} />
          <Route path="/case-studies/apozy" element={<Apozy />} />
          <Route path="/case-studies/radwood" element={<RADwood />} />
          <Route path="/case-studies/velocity-markets" element={<VelocityMarkets />} />
          <Route path="/case-studies/security-career" element={<SecurityCareer />} />

          {/* Blog */}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/why-mvps-fail" element={<WhyMvpsFail />} />
          <Route path="/blog/zero-to-650k-users" element={<SixFiftyKUsers />} />
          <Route path="/blog/discovery-sprint-vs-design-sprint" element={<DiscoveryVsDesignSprint />} />
          <Route path="/blog/mvp-cost-2026" element={<MvpCost2026 />} />
          <Route path="/blog/when-to-hire-fractional-cto" element={<WhenToHireFractionalCto />} />
          <Route path="/blog/yc-lessons" element={<YcLessons />} />
          <Route path="/blog/finding-product-market-fit" element={<FindingPmf />} />

          {/* Cleveland local SEO pages */}
          <Route path="/cleveland/:service" element={<ClevelandRoute />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </StrictMode>
);
